module.exports = __webpack_public_path__ + "img/44_flower.11f47488.jpg";